import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as sectionsActions from '../../redux/actions/sectionsActions';
import { bodyScroll } from '../../utils/utils';
import { userCanEdit } from '../../utils/permissionsOptions';

import RecentAssessments from '../features/dashboard/RecentAssessments';
import NoAssessmentsOnboarding from '../features/dashboard/NoAssessmentsOnboarding';
import UploadAssessmentModal from '../features/dashboard/UploadAssessmentModal';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { showUploadAssessmentModal: false };
  }

  componentDidMount() {
    const { dispatchAssessmentsActions, dispatchSectionsActions, status } = this.props;
    dispatchAssessmentsActions.getAssessments();
    if (!status.sections) {
      dispatchSectionsActions.getSections();
    }
  }

  toggleUploadAssessmentModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({ showUploadAssessmentModal: !prevState.showUploadAssessmentModal }));
  }

  render() {
    const { assessments, institution, users, sections, user, dispatchAssessmentsActions } = this.props;
    const { showUploadAssessmentModal } = this.state;
    const hasAssessments = !!Object.keys(assessments).length;
    const canEdit = userCanEdit(user);

    return (
      <Fragment>
        <Helmet>
          <title>Dashboard</title>
        </Helmet>
        <div className="dashboard-header">
          <div className="row">
            <h1 className="dashboard-header__heading">{institution ? institution.name : ''}</h1>
            <div className="dashboard-header__subheading">{institution ? institution.location : ''}</div>
          </div>
        </div>
        {hasAssessments ? (
          <div className="dashboard-content row">
            <RecentAssessments
              assessments={assessments}
              assessmentsActions={dispatchAssessmentsActions}
              sections={sections}
              users={users}
              currentUser={user}
            />
            <div className="dashboard-content__sidebar">
              {canEdit && (
                <Fragment>
                  <Link to="/assessments/new" className="button button--full-width button--brand button--large dashboard-content__button">
                    Start New Assessment
                  </Link>
                  <p className="dashboard-content__text">
                    Start an assessment to better understand your institution’s injectable medication practices and identify opportunitites for improvement.
                  </p>
                </Fragment>
              )}
              <Fragment>
                <Link to="/assessments" className="button button--full-width button--brand button--large dashboard-content__button">
                  Compare Assessments
                </Link>
                <p className="dashboard-content__text">
                  Assessment modules of the same type (up to three assessments) can be selected to generate a
                  {' '}
                  <span style={{ whiteSpace: 'noWrap' }}>side-by-side</span>
                  {' '}
                  comparison.
                </p>
              </Fragment>
              {canEdit && (
                <Fragment>
                  <button
                    type="button"
                    onClick={this.toggleUploadAssessmentModal}
                    className="button button--full-width button--large dashboard-content__button"
                  >
                    Upload Assessment
                  </button>
                  <p className="dashboard-content__text">
                    Upload a PDF of your scanned paper assessment to the database.
                  </p>
                </Fragment>
              )}
            </div>
          </div>
        ) : (
          <div className="dashboard-content row">
            <NoAssessmentsOnboarding canEdit={canEdit} />
          </div>
        )}
        <div className="dashboard-callouts row">
          {!hasAssessments && canEdit && (
            <div className="dashboard-callouts__col dashboard-callouts__col--small">
              <div className="dashboard-callouts__content">
                <h3 className="dashboard-callouts__heading">
                  Upload Assessment
                </h3>
                <p className="dashboard-callouts__text">
                  Upload a PDF of your scanned paper assessment to the&nbsp;database.
                </p>
              </div>
              <button
                type="button"
                onClick={this.toggleUploadAssessmentModal}
                className="button dashboard-callouts__button"
              >
                Upload PDF
              </button>
            </div>
          )}
          <div
            className={'dashboard-callouts__col ' + (!hasAssessments && !canEdit ? '' : 'dashboard-callouts__col--small')}
          >
            <div className="dashboard-callouts__content">
              <h3 className="dashboard-callouts__heading">
                Reference List
              </h3>
              <p className="dashboard-callouts__text">
                We’ve assembled a library of external resources that could help improve safety&nbsp;practices.
              </p>
            </div>
            <Link to="/reference-list" className="button dashboard-callouts__button">Explore</Link>
          </div>
          {hasAssessments && (
            <div className="dashboard-callouts__col dashboard-callouts__col--small">
              <div className="dashboard-callouts__content">
                <h3 className="dashboard-callouts__heading">
                  Resources
                </h3>
                <p className="dashboard-callouts__text">
                  Access documents to help analyze drug wastage, or create a plan for corrective&nbsp;actions.
                </p>
              </div>
              <Link to="/resources" className="button dashboard-callouts__button">Get Started</Link>
            </div>
          )}
          <div
            className={'dashboard-callouts__col ' + (!hasAssessments && !canEdit ? '' : 'dashboard-callouts__col--small')}
          >
            <div className="dashboard-callouts__content">
              <h3 className="dashboard-callouts__heading">
                Need Some Help?
              </h3>
              <p className="dashboard-callouts__text">
                Start here if you need some guidance on how this whole thing&nbsp;works.
              </p>
            </div>
            <Link to="/help" className="button dashboard-callouts__button">Learn More</Link>
          </div>
        </div>
        <UploadAssessmentModal
          visible={showUploadAssessmentModal}
          toggleUploadAssessmentModal={this.toggleUploadAssessmentModal}
          assessmentsActions={dispatchAssessmentsActions}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.roster[state.users.currentUserId],
    users: state.users.roster,
    assessments: state.assessments.list,
    institution: state.users.institution,
    sections: state.sections,
    status: state.status,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchAssessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    dispatchSectionsActions: bindActionCreators(sectionsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/pages/DashboardPage.js